import { render } from "./Correlation.vue?vue&type=template&id=20c34762"
import script from "./Correlation.vue?vue&type=script&lang=js"
export * from "./Correlation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__